import type { RepoItem } from "./FileRepository";

// Folder actions already include their descendants. Act on each selected tree once.
export function getSelectedRepositoryRoots(
  selectedItems: RepoItem[],
  repositoryItems: RepoItem[],
) {
  const selectedFolderIds = new Set(
    selectedItems.filter((item) => item.isFolder).map((item) => item.id),
  );
  const byId = new Map(repositoryItems.map((item) => [item.id, item]));
  return selectedItems.filter((item) => {
    const visited = new Set<string>();
    let parentId = item.idLocation;
    while (parentId && !visited.has(parentId)) {
      if (selectedFolderIds.has(parentId)) return false;
      visited.add(parentId);
      parentId = byId.get(parentId)?.idLocation ?? null;
    }
    return true;
  });
}
